// .NET appends " (Parameter 'name')" to an ArgumentException message when a parameter name is given, and the
// create endpoint uses that message as the 400 title. It is for developers, so it is not shown to customers.
const PARAMETER_SUFFIX = /\s*\(Parameter '[^']*'\)\s*$/;

// The create endpoint answers a rejected request (an unavailable shipping method, a stale cart line) with a
// 400 whose title is the reason, which the generated client throws as the ProblemDetails body. Anything
// else is not the customer's to act on, so it keeps the generic message.
export function getCreateQuoteErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === "object" && error !== null) {
    const { status, title } = error as { status?: unknown; title?: unknown };
    if (status === 400 && typeof title === "string") {
      const reason = title.replace(PARAMETER_SUFFIX, "").trim();
      if (reason) {
        return reason;
      }
    }
  }
  return fallback;
}
